import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { UserSessionService } from './user-session.service';
import { GuardService } from './guard.service';
import { AuthService } from '../auth/auth.service'

@Injectable({
  providedIn: 'root'
})
export class StateService extends BaseService {

  constructor(
    public LibService: LibService,
    public AuthService: AuthService,
    public userSessionService: UserSessionService,
    public guardService: GuardService
  ) {
    super(LibService, AuthService)
    this.baseApi = environment.rootApiFoundation
    this.model = 'states'
  }

  getStates(): Observable<any> {
    return this.libService.getDataWithAccessToken<any>(this.tokenId, this.baseApi, `${this.model}`);
  }


  getState(id: any): Observable<any> {
    return this.libService.getDataWithAccessToken<any>(this.tokenId, this.baseApi, `${this.model}/${id}`);
  }

  statesOfTheItemCategories(itemCategoryCodes: any){
    return this.libService.postDataWithAccessToken<any>(this.tokenId, {itemCategoryCodes: itemCategoryCodes}, this.baseApi, `${this.model}/statesOfTheItemCategories`);
  }

  statesByComponents(componentCodes: any){
    return this.libService.postDataWithAccessToken<any>(this.tokenId, {componentCodes: componentCodes}, this.baseApi, `${this.model}/statesByComponents`);
  }

  getStateCategory(id: any){
    return this.libService.getDataWithAccessToken<any>(this.tokenId, this.baseApi, `${this.model}/${id}/getStateCategory`);
  }

  getStateCategoryByCode(code: any){
    return this.libService.getDataWithAccessToken<any>(this.tokenId, this.baseApi, `${this.model}/${code}/getStateCategoryByCode`);
  }

  

}